/** @example countLeadingDecimalZeroes(0.001) === 2 */
const countLeadingDecimalZeroes = (num: number): number => {
  const match = num.toString().match(/(\.0*)/)
  return match ? match[0].length - 1 : 0
}

export default countLeadingDecimalZeroes
